<div id="add-simulation-type" class="share-now-cotainer position-relative">
    <span class="close-icon-add-simulation-type" style="cursor: pointer" (click)="onCloseModal()">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.26211 15.9621L0.0371094 14.7371L6.77461 7.99961L0.0371094 1.26211L1.26211 0.0371094L7.99961 6.77461L14.7371 0.0371094L15.9621 1.26211L9.22461 7.99961L15.9621 14.7371L14.7371 15.9621L7.99961 9.22461L1.26211 15.9621Z"
                fill="#ACACAC"
            />
        </svg>
    </span>
    <div class="box-header">
        <h2 class="font-bold m-0">Share Simulation</h2>
    </div>
    <div class="form">
        <form>
            <div class="form-field w-100 invite-people" appearance="fill">
                <label class="label">SHARE ON EMAIL</label>
                <div class="share-on-email-chip-list" appearance="fill">
                    <mat-chip-list #chipList aria-label="Share on email">
                        <mat-chip *ngFor="let email of emails" (removed)="remove(email)">
                            {{ email.email }}
                            <button matChipRemove>
                                <mat-icon>
                                    <svg
                                        width="18"
                                        height="19"
                                        viewBox="0 0 18 19"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle cx="9" cy="9.5" r="9" fill="#086972" />
                                        <path
                                            d="M5.63105 13.4811L5.01855 12.8686L8.3873 9.4998L5.01855 6.13105L5.63105 5.51855L8.9998 8.8873L12.3686 5.51855L12.9811 6.13105L9.6123 9.4998L12.9811 12.8686L12.3686 13.4811L8.9998 10.1123L5.63105 13.4811Z"
                                            fill="white"
                                        />
                                    </svg>
                                </mat-icon>
                            </button>
                        </mat-chip>
                        <input
                            placeholder="Enter share on email..."
                            class="input-text border-0"
                            [matChipInputFor]="chipList"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="addOnBlur"
                            (matChipInputTokenEnd)="add($event)"
                        />
                    </mat-chip-list>
                </div>
                <div class="lbl-add-multip-email">You can add multiple emails</div>
            </div>
            <div class="form-field w-100 mb-10" appearance="fill">
                <mat-checkbox class="share-pdf" [checked]="true"> Share Simulation PDF </mat-checkbox>
            </div>
            <div class="form-field w-100 mb-10" appearance="fill">
                <mat-checkbox class="share video" name="download" [(ngModel)]="download" [checked]="download">
                    Download
                </mat-checkbox>
            </div>

            <div class="form-field w-100 mb-10" appearance="fill">
                <mat-checkbox
                    class="share video"
                    name="sendViaEmail"
                    [(ngModel)]="shareViaEmail"
                    [checked]="shareViaEmail"
                >
                    Share Via Email
                </mat-checkbox>
            </div>
            <!-- <div class="form-field w-100" appearance="fill">
                <mat-checkbox class="share video" [checked]="false"> Share Simulation Video </mat-checkbox>
            </div> -->

            <button
                mat-button
                type="button"
                class="btn-share-now font-bold btn-common-style float-right"
                (click)="btnShareNow()"
                disabled="{{ !download && !shareViaEmail }}"
            >
                Share Now
            </button>
        </form>
    </div>
</div>
